import { render, staticRenderFns } from "./AccountSettingPermissions.vue?vue&type=template&id=06770210&"
import script from "./AccountSettingPermissions.vue?vue&type=script&lang=js&"
export * from "./AccountSettingPermissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports